"use client";

import { c as _c } from "react/compiler-runtime";
import Modal from "@/shared/ui/templates/Modal";
import { ModalProps } from "@/shared/types/interface/modal";
import { TextButton } from "@/shared/ui/atoms";
import { TreatmentFilterModalBody } from "@/features/search-result/ui/organisms";
import { useState } from "react";
import { FilterValue } from "@/shared/types/type/search";
import { useTranslations } from "next-intl";
import { useGetLocale } from "@/shared/hooks/useGetLocale";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
interface TreatmentFilterModalProps extends ModalProps {
  treatmentList: FilterValue[];
  hideTreatmentAllOption?: boolean;
  defaultTreatmentId?: number;
}
const TreatmentFilterModal = t0 => {
  const $ = _c(34);
  const {
    open,
    onClose,
    treatmentList,
    hideTreatmentAllOption,
    defaultTreatmentId
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const locale = useGetLocale();
  const t = useTranslations();
  const pathParams = useSearchParams();
  let t1;
  if ($[0] !== pathParams) {
    t1 = pathParams?.get("query");
    $[0] = pathParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const keyword = t1;
  let t2;
  if ($[2] !== pathParams) {
    t2 = pathParams?.get("region");
    $[2] = pathParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const regionIds = t2;
  let t3;
  if ($[4] !== pathParams) {
    t3 = pathParams?.get("treatment");
    $[4] = pathParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const treatmentIds = t3;
  let t4;
  if ($[6] !== defaultTreatmentId || $[7] !== treatmentIds) {
    t4 = treatmentIds ?? defaultTreatmentId?.toString() ?? "";
    $[6] = defaultTreatmentId;
    $[7] = treatmentIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const [selectedTreatment, setSelectedTreatment] = useState(t4);
  let t5;
  if ($[9] !== keyword || $[10] !== locale || $[11] !== onClose || $[12] !== pathname || $[13] !== regionIds || $[14] !== router || $[15] !== selectedTreatment) {
    t5 = async () => {
      onClose();
      if (pathname?.includes("/search/ranking")) {
        const params = new URLSearchParams();
        if (regionIds) {
          params.set("region", regionIds);
        }
        if (selectedTreatment) {
          params.set("treatment", selectedTreatment);
        }
        const query = params.toString();
        router.push(`/${locale}/search/ranking${query ? `?${query}` : ""}`);
        return;
      }
      const keywordQuery = keyword ? `?query=${keyword}` : "?";
      const regionQuery = regionIds ? `&region=${regionIds}` : "";
      router.push(`/${locale}/search/result${keywordQuery}${regionQuery}&treatment=${selectedTreatment}`);
    };
    $[9] = keyword;
    $[10] = locale;
    $[11] = onClose;
    $[12] = pathname;
    $[13] = regionIds;
    $[14] = router;
    $[15] = selectedTreatment;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const searchTreatment = t5;
  let t6;
  if ($[17] !== t) {
    t6 = t("commonSearch.filter.treatment");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== hideTreatmentAllOption || $[20] !== selectedTreatment || $[21] !== treatmentList) {
    t7 = <TreatmentFilterModalBody treatmentList={treatmentList} selectedTreatment={selectedTreatment} setSelectedTreatment={setSelectedTreatment} hideTreatmentAllOption={hideTreatmentAllOption} />;
    $[19] = hideTreatmentAllOption;
    $[20] = selectedTreatment;
    $[21] = treatmentList;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t) {
    t8 = t("commonButtons.complete");
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== searchTreatment || $[26] !== t8) {
    t9 = <div className="fixed bottom-0 w-full max-w-[600px] mx-auto bg-white py-3 px-4 border-t border-[#EAEBEC]"><TextButton text={t8} className="w-full py-3 bg-primary-600 text-white rounded-lg font-semibold disabled:bg-[#F7F7F7] disabled:text-[#989BA2] disabled:cursor-not-allowed" onClick={searchTreatment} /></div>;
    $[25] = searchTreatment;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== onClose || $[29] !== open || $[30] !== t6 || $[31] !== t7 || $[32] !== t9) {
    t10 = <Modal open={open} onClose={onClose} height="90%" title={t6}>{t7}{t9}</Modal>;
    $[28] = onClose;
    $[29] = open;
    $[30] = t6;
    $[31] = t7;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
export default TreatmentFilterModal;